import { combine, separate, splitPathString } from 'flubber';

(function () {
  'use strict';

  var ORIG = 'M937.804 527.83C937.804 555.051 916.737 577.319 890.987 577.319H881.389C855.639 577.319 834.573 555.051 834.573 527.83V257.353L937.804 151.265V527.83ZM654.023 14.6475C672.129 -4.73518 701.931 -4.88746 720.237 14.252L727.049 21.3613C745.355 40.5009 745.528 72.0051 727.423 91.3574L286.424 562.68C268.318 582.032 238.517 582.215 220.21 563.075L213.37 555.936C195.092 536.796 194.92 505.322 213.025 485.97L654.023 14.6475ZM861.522 14.6475C879.628 -4.7352 909.401 -4.88754 927.708 14.252L934.548 21.3613C952.854 40.501 953.027 72.0051 934.922 91.3574L493.924 562.68C475.818 582.032 446.016 582.215 427.709 563.075L420.869 555.936C402.563 536.796 402.419 505.322 420.524 485.97L861.522 14.6475ZM454.467 14.6445C472.572 -4.7382 502.375 -4.89066 520.682 14.249L527.492 21.3584C545.799 40.498 545.972 72.0021 527.866 91.3545L86.8682 562.677C68.7627 582.029 38.96 582.212 20.6533 563.072L13.8418 555.933C-4.4647 536.793 -4.63661 505.319 13.4688 485.967L454.467 14.6445ZM1177.31 6.93262C1319.69 6.93262 1319.76 178.409 1319.76 178.582C1319.76 269.146 1277.46 292.114 1277.46 292.114C1277.57 292.185 1319.76 318.365 1319.76 409.93C1319.77 410.256 1320.66 577.295 1177.31 577.295H970.616L1070.97 468.169H1177.31C1177.31 468.169 1221.71 467.743 1221.71 409.93C1221.71 352.116 1177.31 345.948 1177.31 345.948H970.616L1070.97 236.821H1177.31C1177.31 236.821 1221.71 240.771 1221.71 178.582C1221.71 116.393 1177.31 116.06 1177.31 116.06H970.616L1070.97 6.93262C1070.85 6.93262 1035.09 6.93262 1177.31 6.93262Z';
  var VBW = 1320;
  var VBH = 578;
  var DURATION = 900;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scalePath(d, s, tx, ty) {
    var segs = d.match(/[MLHVCSQTAZmlhvcsqtaz][^MLHVCSQTAZmlhvcsqtaz]*/g);
    if (!segs) return d;

    return segs.map(function (seg) {
      var cmd = seg[0];
      if (cmd === 'Z' || cmd === 'z') return cmd;

      var nums = seg.slice(1).match(/-?[\d.]+(?:e[+-]?\d+)?/g);
      if (!nums) return seg;
      nums = nums.map(Number);

      switch (cmd) {
        case 'M': case 'L': case 'T': case 'C': case 'S': case 'Q':
          for (var i = 0; i < nums.length; i += 2) {
            nums[i] = nums[i] * s + tx;
            nums[i + 1] = nums[i + 1] * s + ty;
          }
          break;
        case 'H':
          for (var i = 0; i < nums.length; i++) nums[i] = nums[i] * s + tx;
          break;
        case 'V':
          for (var i = 0; i < nums.length; i++) nums[i] = nums[i] * s + ty;
          break;
      }

      return cmd + nums.join(',');
    }).join('');
  }

  function ease(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /**
   * Fullscreen candidates for the hero video, in priority order — same
   * semantics as <source media> inside <video>: the first entry whose media
   * query matches wins, an entry without one is the default. The list itself
   * (which file, which query, and why) is authored in front-page.php, next to
   * the assets; this side just resolves it, so adding a variant never means
   * touching the JS. data-fullscreen-src is the single-file fallback for when
   * the list is missing or unparseable.
   */
  function readFullscreenSources(video) {
    var sources = [];
    var raw = video.getAttribute('data-fullscreen-sources');

    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          parsed.forEach(function (entry) {
            if (!entry || typeof entry.src !== 'string' || !entry.src) return;
            sources.push({
              src: entry.src,
              query: entry.media ? window.matchMedia(entry.media) : null,
            });
          });
        }
      } catch (err) {
        sources = [];
      }
    }

    var fallback = video.getAttribute('data-fullscreen-src');
    if (!sources.length && fallback) {
      sources.push({ src: fallback, query: null });
    }

    return sources;
  }

  function pickFullscreenSrc(sources) {
    for (var i = 0; i < sources.length; i++) {
      if (!sources[i].query || sources[i].query.matches) return sources[i].src;
    }
    return '';
  }

  function initHeroMorph(root) {
    var masked = root.querySelector('.js-hero-masked');
    var video = root.querySelector('.js-hero-video');
    var pathEl = root.querySelector('.js-hero-path');
    var playBtn = root.querySelector('.js-hero-play');
    var closeBtn = root.querySelector('.js-hero-close');

    if (!masked || !video || !pathEl || !playBtn || !closeBtn) return;

    var loopSrc = video.src;
    var fullscreenSources = readFullscreenSources(video);
    // Which master is currently loaded in the element. Empty while the hero
    // is showing its silent loop — it's also what tells the orientation
    // handler below that there's nothing to swap yet, which matters during
    // the 900ms morph, when isExpanded is already true but goFullscreen()
    // hasn't run.
    var activeFullscreenSrc = '';
    // The initial mask lives only in the inline style (no CSS fallback on
    // .hero__masked), so capture it here to restore it on collapse — otherwise
    // clearing the inline clip-path would leave the video unmasked.
    var initialClipPath = masked.style.clipPath || 'url(#hero-clip-preview)';
    var isExpanded = false;
    var animId = null;
    var expandInterp = null;
    var collapseInterp = null;

    function buildInterpolators() {
      var w = root.offsetWidth;
      var h = root.offsetHeight;
      var scale = Math.min(w / VBW, h / VBH);
      var ox = (w - VBW * scale) / 2;
      var oy = (h - VBH * scale) / 2;

      var subPaths = splitPathString(ORIG).map(function (sp) {
        return scalePath(sp, scale, ox, oy);
      }).filter(function (sp) {
        return sp && sp.length > 1;
      });

      var rect = 'M0,0L' + w + ',0L' + w + ',' + h + 'L0,' + h + 'Z';

      expandInterp = combine(subPaths, rect, { string: true, single: true, maxSegmentLength: 30 });
      collapseInterp = separate(rect, subPaths, { string: true, single: true, maxSegmentLength: 30 });

      if (!isExpanded) {
        pathEl.setAttribute('d', expandInterp(0));
      }
    }

    function animate(interp, onDone) {
      if (animId) cancelAnimationFrame(animId);
      var start = performance.now();

      function tick(now) {
        var t = Math.min((now - start) / DURATION, 1);
        pathEl.setAttribute('d', interp(ease(t)));
        if (t < 1) {
          animId = requestAnimationFrame(tick);
        } else {
          animId = null;
          if (onDone) onDone();
        }
      }

      animId = requestAnimationFrame(tick);
    }

    function goFullscreen() {
      masked.style.clipPath = 'none';
      masked.classList.add('is-fullscreen');

      var src = pickFullscreenSrc(fullscreenSources);
      if (src) {
        activeFullscreenSrc = src;
        video.src = src;
      }

      video.muted = false;
      video.controls = true;
      // Il loop vale solo per il mascherino in home, che è un fondale muto: il
      // corporate è un film di 3 minuti e alla fine deve fermarsi, non
      // ripartire da capo. collapse() lo riaccende tornando al loop. Cambiare
      // .src non tocca questa proprietà, quindi resta spento anche dopo uno
      // swap di master alla rotazione.
      video.loop = false;
      video.currentTime = 0;
      video.play().catch(function () {});
      closeBtn.hidden = false;
      closeBtn.focus();
      document.body.style.overflow = 'hidden';
    }

    function expand() {
      if (isExpanded || animId) return;
      isExpanded = true;

      if (reducedMotion) {
        goFullscreen();
        return;
      }

      animate(expandInterp, goFullscreen);
    }

    function collapse() {
      if (!isExpanded || animId) return;

      video.muted = true;
      video.controls = false;
      video.loop = true; // riacceso: il fondale mascherino gira in loop (vedi goFullscreen)
      closeBtn.hidden = true;
      document.body.style.overflow = '';
      masked.classList.remove('is-fullscreen');
      // Restore the initial mask (not ''): the inline clip-path is the only
      // source of the mask, so re-point it at the clip path we morph.
      masked.style.clipPath = initialClipPath;

      if (activeFullscreenSrc) {
        activeFullscreenSrc = '';
        video.src = loopSrc;
        video.muted = true;
        video.play().catch(function () {});
      }

      buildInterpolators();

      if (reducedMotion) {
        isExpanded = false;
        playBtn.focus();
        return;
      }

      pathEl.setAttribute('d', collapseInterp(0));

      animate(collapseInterp, function () {
        isExpanded = false;
        pathEl.setAttribute('d', expandInterp(0));
        playBtn.focus();
      });
    }

    /**
     * Rotating the phone mid-playback flips which master fits the screen, so
     * swap the file under the player instead of leaving the 2.39:1 master
     * cropped to a sliver on a portrait screen. The playhead carries over,
     * clamped because the two cuts aren't the same length (175.6s vs 179.4s).
     *
     * The explicit pause() on the else branch is load-bearing, not defensive:
     * assigning .src re-runs the resource selection algorithm, which re-arms
     * the element's `autoplay` attribute, so without it a video the user had
     * paused would start itself again on rotation. Calling pause() here (at
     * loadedmetadata, before the autoplay kicks in at HAVE_FUTURE_DATA) also
     * clears the can-autoplay flag, which is what actually holds it back.
     */
    function syncFullscreenSource() {
      if (!activeFullscreenSrc) return;

      var next = pickFullscreenSrc(fullscreenSources);
      if (!next || next === activeFullscreenSrc) return;

      var resumeAt = video.currentTime;
      var wasPlaying = !video.paused;

      activeFullscreenSrc = next;
      video.src = next;

      video.addEventListener('loadedmetadata', function onMeta() {
        video.removeEventListener('loadedmetadata', onMeta);
        if (isFinite(video.duration)) {
          video.currentTime = Math.min(resumeAt, Math.max(video.duration - 0.25, 0));
        }
        if (wasPlaying) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    fullscreenSources.forEach(function (source) {
      if (!source.query) return;
      if (source.query.addEventListener) {
        source.query.addEventListener('change', syncFullscreenSource);
      } else if (source.query.addListener) {
        source.query.addListener(syncFullscreenSource); // Safari < 14
      }
    });

    buildInterpolators();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!isExpanded && !animId) buildInterpolators();
      }, 200);
    });

    playBtn.addEventListener('click', expand);
    closeBtn.addEventListener('click', collapse);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isExpanded && !animId) collapse();
    });
  }

  var sections = document.querySelectorAll('.js-hero-morph');
  for (var i = 0; i < sections.length; i++) {
    initHeroMorph(sections[i]);
  }
})();


/**
 * Count-up effect for the home "numbers" section.
 * Animates the numeric part of each `.js-counter` when it scrolls into view,
 * preserving any non-numeric suffix (e.g. "+", "k+"). Respects reduced motion.
 */
(function () {
  'use strict';

  var counters = document.querySelectorAll('.js-counter');
  if (!counters.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 1600;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function format(value, suffix) {
    return value.toLocaleString('it-IT') + suffix;
  }

  function animate(el) {
    var target = parseInt(el.getAttribute('data-value'), 10) || 0;
    var suffix = el.getAttribute('data-suffix') || '';

    if (reduceMotion || target === 0) {
      el.textContent = format(target, suffix);
      return;
    }

    var start = null;
    function tick(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / DURATION, 1);
      el.textContent = format(Math.round(easeOutCubic(progress) * target), suffix);
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    for (var i = 0; i < counters.length; i++) {
      observer.observe(counters[i]);
    }
  } else {
    for (var j = 0; j < counters.length; j++) {
      animate(counters[j]);
    }
  }
})();
